
import type { PropType } from 'vue'
import type { AppMessages } from '../../../models'
import { defineComponent, ref } from 'vue'
import UploadFile from '../../upload-file.component.vue'
import { EpbBaseInput } from '../epb-base-input'

export default defineComponent({
  name: 'EpbDragAndDrop',
  components: { UploadFile, EpbBaseInput },
  props: {
    help: {
      type: String,
      default: undefined,
    },
    helpIcon: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
    supportedFormats: {
      type: Array as PropType<Array<string>>,
      required: true,
    },
    disabled: Boolean,
    required: Boolean,
    messages: {
      type: Object as PropType<AppMessages['uploadFile']>,
      required: true,
    },
  },
  setup() {
    const baseClass = 'epb-drag-and-drop'

    const uploadFileRef = ref()

    const reset = (): void => {
      uploadFileRef.value.reset()
    }

    return {
      baseClass,
      uploadFileRef,
      reset,
    }
  },
})
